module.exports = __webpack_public_path__ + "static/img/logo.c39f863.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/App/logo.png
// module id = UWub
// module chunks = 1